export interface CommandResult {
  commandId: number;
  identifier: string;
  isSuccessful: boolean;
  errorMessage: string;
  target: any;
  isExecuted: boolean;
}
